module.exports = __webpack_public_path__ + "static/img/1_1.e1b17625.jpg";